import { BackendService } from '../../services/new-http/backend.service';
import { IClientsTradedOperationsRequestParams } from '../../../shared/models/advanced-platforms/requests-model';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { platformData } from './platform-data';

@Injectable({
  providedIn: 'root',
})
export class AdvancedPlatformsService extends BackendService {
  public getPlatformsList() {
    return of(platformData);
  }

  public getSubscriptions() {
    return this.api.get('/platform/subscriptions');
  }

  public setSubscription(body: any) {
    return this.api.post('/platform/subscriptions', body);
  }

  public getPendingSubscriptions() {
    return this.api.get('/platform/pendingSubscriptions');
  }

  public getClientsTradedOperationsCount(
    reqParams: IClientsTradedOperationsRequestParams,
  ) {
    const urlParams = `
      ?symbol=${reqParams.symbol}
      &isStrategy=${reqParams.isStrategy}
      &plataform=${reqParams.plataform}
      &status=${reqParams.status}
      &orderMarketType=${reqParams.orderMarketType}
      &initialDate=${reqParams.initialDate}
      &finalDate=${reqParams.finalDate}`.replace(/\s+/g, '');

    return this.webapi.get(encodeURI(`/exchange/order/client/count${urlParams}`));
  }
}
